import React from 'react';
import { graphql } from 'gatsby';
import { PrismicText } from '@prismicio/react';
import css from './HeroCarousel.module.scss';
import { useKeenSlider } from 'keen-slider/react';
import { GatsbyImage } from 'gatsby-plugin-image';
import cn from 'classnames';

const HeroCarousel = ({ slice }) => {
  const [sliderRef] = useKeenSlider({
    slides: {
      perView: slice.primary.carousel_image_size === 'large' ? 1.2 : 3.2,
      spacing: 24,
      origin: 'center',
    },
    breakpoints: {
      '(max-width: 768px)': {
        slides: {
          perView: slice.primary.carousel_image_size === 'large' ? 1.1 : 1.6,
          spacing: 12,
          origin: 'center',
        },
      },
    },
  });

  return (
    <>
      <section className={css.wrapper}>
        <div className={css.container}>
          <div className={css.heading}>
            <h1 className={css.eyebrow}>{slice.primary.eyebrow}</h1>
            <h2>
              <PrismicText field={slice.primary.title.richText} />
            </h2>
          </div>
        </div>
        <div ref={sliderRef} className={cn('keen-slider', css.slider_container)}>
          {slice.items.map((item, idx) => {
            return (
              <div key={idx} className={cn('keen-slider__slide', css.slide)}>
                <GatsbyImage
                  objectFit="cover"
                  loading="eager"
                  className={css.image}
                  image={item.image.gatsbyImageData}
                  alt={item.image.alt || ''}
                />
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
};

export const query = graphql`
  fragment MarketplaceTypePageDataBodyHeroCarousel on PrismicMarketplaceTypePageDataBodyHeroCarousel {
    primary {
      carousel_image_size
      eyebrow
      title {
        richText
      }
    }
    items {
      image {
        gatsbyImageData(placeholder: NONE)
        alt
      }
    }
  }
  fragment FeatureHighlightPageDataBodyHeroCarousel on PrismicFeatureHighlightPageDataBodyHeroCarousel {
    primary {
      carousel_image_size
      eyebrow
      title {
        richText
      }
    }
    items {
      image {
        gatsbyImageData(placeholder: NONE)
        alt
      }
    }
  }
  fragment LandingPageDataBodyHeroCarousel on PrismicLandingPageDataBodyHeroCarousel {
    primary {
      carousel_image_size
      eyebrow
      title {
        richText
      }
    }
    items {
      image {
        gatsbyImageData(placeholder: NONE)
        alt
      }
    }
  }
`;

export default HeroCarousel;
